"use client";

import styles from "../../../styles/contact/contactAddress.module.css";

export default function ContactAddress() {
  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Diagnomed Private Limited</h2>
      
      <div className={styles.content}>
        <div className={styles.addressColumn}>
          <div className={styles.textGroup}>
            <h3 className={styles.heading}>Registered Office:</h3>
            <p className={styles.address}>
              3rd H 211 Nehru Nagar, Ghaziabad 201001
            </p>
          </div>
          <div className={styles.mapContainer}>
            <iframe
              title="Registered Office Google Map"
              src="https://maps.google.com/maps?q=3rd%20H%20211%20Nehru%20Nagar%2C%20Ghaziabad%20201001&t=&z=14&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className={styles.addressColumn}>
          <div className={styles.textGroup}>
            <h3 className={styles.heading}>Corporate Office:</h3>
            <p className={styles.address}>
              Unit No.736, 737, IT Tower 2, Golden Grande, Plot No.19 Techzone 4, Greater Noida West, U.P.
            </p>
          </div>
          <div className={styles.mapContainer}>
            <iframe
              title="Corporate Office Google Map"
              src="https://maps.google.com/maps?q=Golden%20Grande%2C%20Techzone%204%2C%20Greater%20Noida%20West&t=&z=14&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
